<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="submitCallback"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-row :gutter="24">
        请先迁移原会员用户
      </a-row>
      <a-row :gutter="24">
        <a-form-item>
          <a-select
            show-search
            placeholder="请选择会员等级"
            style="width: 100%"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            @focus="getLoadData"
            @search="getLoadData"
            v-decorator="[
                    'newGroupId',
                    {rules: [
                      {
                        required: true,
                        message: '请选择会员等级'
                      }
                    ]}]"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in data" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-row>
  </a-form>
  </j-modal>
</template>

<script>

  import debounce from 'lodash.debounce';
  import { getAction } from '@/api/manage';
  export default {
    name: 'MemberLevelMoveModal',
    components: {
    },
    data () {
      this.getLoadData = debounce(this.getLoadData, 800);
      this.lastLoad = 0;
      return {
        title:'提示',
        form: this.$form.createForm(this), //form对象
        width:400,
        visible: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        groupId:undefined,
        data:[],
        fetching: false,
        url:{
          loadData: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmGroup/migrateMemberList",
          moveMember: process.env.VUE_APP_CMS_CUSTOMER + "/member/ctMmGroup/migrateMember",
        }
      }
    },
    created () {
      //备份model原始值
    },
    methods: {
      add (groupId) {
        this.visible=true
        this.groupId = groupId;
        this.data=[];
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      getLoadData(name){
        this.lastLoad += 1;
        const currentLoad = this.lastLoad;
        this.fetching = true;
        getAction(this.url.loadData,{name:name,groupId:this.groupId}).then(res=>{
          this.fetching = false;
          if (res.success) {
            if (currentLoad != this.lastLoad) {
              return;
            }
            let list = [];
            for (let i = 0; i < res.result.length; i++) {
              list.push({
                key:res.result[i].id,
                value:res.result[i].id,
                text:res.result[i].name
              })
            }
            this.data = list;
          } else {
            this.$message.warning(res.message);
          }
        })
      },
      submitCallback(){
        let that = this;
        this.form.validateFields((err, values) => {
          if(!err){
            let formData = Object.assign({}, values);
            let newGroupId = formData.newGroupId;
            getAction(this.url.moveMember,{oldGroupById:this.groupId,newGroupById:newGroupId}).then(
              res=>{
                if(res.success){
                  that.$message.success("会员迁移成功");
                  that.$emit('ok',this.groupId);
                  that.close();
                }else{
                  that.$message.warning(res.message);
                }
              });
          }
        });
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>